import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsProfilesShowResponseType } from "~/domains";

const request =
  async (): Promise<ApisAdminOperatorsProfilesShowResponseType> => {
    const response =
      await new ApiClient().get<ApisAdminOperatorsProfilesShowResponseType>(
        "/api/admin_operators/profile",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsProfilesShow = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApisAdminOperatorsProfilesShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAdminOperatorsProfilesShow"],
    queryFn: request,
    cacheTime: 0,
  });
};
